import { Stack } from '@mui/material';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockSwitchField } from '../../../ConfigFields/Switch';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';

export function PracticeFormFields() {
  const { value: isSelectPracticeIdsEnabled } = useSelectedNodeField<boolean>(
    'config.isSelectPracticeIdsEnabled'
  );

  return (
    <>
      <Stack direction="column" spacing={2}>
        <BlockSwitchField
          fieldName="config.isSelectPracticeIdsEnabled"
          label="Select Practice IDs"
          helperText="If enabled, you can select specific Practice IDs. Otherwise, the default Practice associated with this flow run will be used."
        />
        {isSelectPracticeIdsEnabled && (
          <BlockValueTemplateField
            fieldName="config.practiceIds"
            label="List of Practice IDs"
            isMultiline
          />
        )}
      </Stack>
    </>
  );
}
